import React from 'react';
import { WhatsAppIcon } from './IconComponents';
import Tooltip from './Tooltip';

const FloatingWhatsApp: React.FC = () => {
    return (
        <div className="fixed bottom-6 left-6 z-50 flex flex-col items-center space-y-2">
            <Tooltip text="Chat with us on WhatsApp" position="right">
                <a
                    href="https://wa.me/918328080730"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#1ebe57] hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-[#25D366]/50"
                    aria-label="Contact us on WhatsApp"
                >
                    <WhatsAppIcon className="w-8 h-8" />
                </a>
            </Tooltip>
        </div>
    );
};

export default FloatingWhatsApp;
